import NoPromos from './NoPromos.mjs';
import RowCard from './RowCard.mjs';

export default function RowCards({ promos, rowCardHtag }) {
  let content = <NoPromos />;

  if (promos && promos.events.length > 0) {
    const promoElements = promos.events.map(p => {
      return (
        <RowCard
          key={'promo-' + p.eventId}
          promo={p}
          rowCardHtag={rowCardHtag}
        />
      );
    });

    content = (
      <div className="card-wrapper container-wide">
        <div className="container-wide-right">
          <div className="d-flex gap-3 gap-lg-4 over-scroll pb-3 pe-3 pe-sm-5">
            {promoElements}
          </div>
        </div>
      </div>
    );
  }

  return (
    content
  );
}
